/* eslint-disable @angular-eslint/component-selector */
import { Component, Input } from '@angular/core';
import { Prescription } from '../../../core/models/prescription.model';

import { PrescriptionCapturesComponent } from '../prescription-captures/prescription-captures.component';

@Component({
    selector: '[app-prescription-list-row-detail]',
    templateUrl: './prescription-list-row-detail.component.html',
    styleUrls: ['./prescription-list-row-detail.component.scss'],
    imports: [PrescriptionCapturesComponent]
})
export class PrescriptionListRowDetailComponent {
  @Input() activeCaptureId: number;
  @Input() isOpen: boolean;
  @Input() prescription: Prescription;

  constructor() {}
}
